import React, {useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {SortDirection as SortDirections} from 'src/openapi/admin/models/SortDirection';

import {SortHeaderWithDataTable} from '@pb/kit-component-sort-header';

import {HEADERS} from '../../constants';
import {assignedUsersStateActions, assignedUsersStateSelector} from '../../slices/assigned-users-state-slice';

import type {AdminSortField} from 'src/openapi/admin/models/AdminSortField';
import type {SortDirection} from 'src/openapi/admin/models/SortDirection';

type Props = {
    column: string,
    sortField: AdminSortField,
};

export const SortHeader = ({column, sortField}: Props) => {
    const dispatch = useDispatch();
    const cacheKeys = useSelector(assignedUsersStateSelector);

    const sort = useCallback((direction: ('ASC' | 'DESC')) => {
        dispatch(assignedUsersStateActions.setSortCriteria({
            direction: direction as SortDirection,
            field: sortField,
        }));
    }, [dispatch, sortField]);

    return (
        <SortHeaderWithDataTable
            caption={HEADERS[column]}
            defaultDirection={SortDirections.ASC}
            direction={cacheKeys.sortCriteria.field === sortField
                ? cacheKeys.sortCriteria.direction
                : undefined}
            onSort={sort}
        />
    );
};
